import axios from 'axios';
import { useState, useEffect } from 'react';
import { getVisorID } from '../utils/misc';

export const useConfig = () => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fallback dev env
        const fetchFile = async () => {
            console.warn('Fetching static config file as fallback...');
            try {
                const response = await fetch('config.json');
                if (!response.ok) throw new Error('Config not found or inaccessible');
                const data = await response.json();
                setConfig(data);
                setLoading(false);
            } catch (error) {
                console.error('Error loading config:', error);
                setLoading(false);
            }
        };

        // Cargar configuración solo una vez
        const fetchConfig = async () => {

            let visorID = getVisorID();

            // Laravel includes axios with auth credentials
            // use it if available!
            if (window.axios) {
                axios.get(`/api/visor/${visorID}/config`)
                    .then(response => {
                        console.debug('CONFIG RESPONSE', response);
                        setConfig(response.data);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error('Error loading config:', error);
                        fetchFile();
                    });
            } else {
                console.error('Axios not available!');
                fetchFile();
            }
        };

        if (window.visorConfig) {
            // A local config exists, load it!
            // console.log('🔹 Local global config found! Loading it...');
            setConfig(window.visorConfig);
            setLoading(false);
        } else {
            // Fetch config file
            console.log('Fetching config file...');
            fetchConfig();
        }
    }, []);

    return { config, loading, error };
};
